import { useEffect, useState, useCallback } from 'react';
import { useAuth, useChangeMessageState } from '@BUP/hooks';
import { BraveBupAPI } from '@BUP/services/Axios';
import {
  ADMIN,
  ECE,
  COMMENT_OPEN,
} from '@BUP/constants';
import { message } from 'antd';

export function useInboxMessages() {
  const { user } = useAuth();
  const [handleChangeMessageState] = useChangeMessageState();
  const [listState, setListState] = useState({
    isLoading: false,
    messages: [],
    error: null
  });

  const role = user?.roles?.type;
  const organizationId = user?.organizations?.id;
  const enrollmentId = user?.enrollmentId;

  const getMessages = useCallback(async () => {
    setListState((prevState) => ({
      ...prevState,
      error: null,
      isLoading: true
    }));
    try {
      if (role == ECE || role == ADMIN) {
        const response = await BraveBupAPI.get('/comments', {
          params: {
            parent_comment_id: 'null',
            organizationId: organizationId
          }
        })
        const messages = response.data;
        const sortedMessages = messages.sort((a, b) => new Date(b?.createdAt) - new Date(a?.createdAt));
        setListState((prevState) => ({
          ...prevState,
          messages: sortedMessages
        }));
      } else {
        const response = await BraveBupAPI.get('/comments', {
          params: {
            parent_comment_id: 'null',
            organizationId: organizationId,
            enrollmentId: enrollmentId
          }
        })
        const messages = response.data;
        const sortedMessages = messages.sort((a, b) => new Date(b?.createdAt) - new Date(a?.createdAt));
        setListState((prevState) => ({
          ...prevState,
          messages: sortedMessages
        }));
      }

    } catch (e) {
      console.log("useInboxMessages error", e)
      setListState((prevState) => ({
        ...prevState,
        error: e
      }));
    }
    finally {
      setListState((prevState) => ({
        ...prevState,
        isLoading: false
      }));
    }
  }, [role, organizationId, enrollmentId, setListState]);

  const setMessageState = async (messageId, newState) => {
    const moveTo = newState === COMMENT_OPEN ? "Bandeja de Entrada" : "Casos Archivados";
    try {
      const response = await handleChangeMessageState(messageId, newState);
      setListState((prevState) => ({
        ...prevState,
        messages: prevState.messages.filter(message => message.id !== messageId)
      }));
      message.success(`Mensaje movido exitosamente a ${moveTo}.`, 8);
    } catch (e) {
      console.log("setMessageState error", e);
      message.error('Ocurrio un error al mover el mensaje, vuelve a intentarlo.', 7);
    }
  }

  useEffect(() => {
    getMessages();
  }, [getMessages]);


  return {
    isLoading: listState.isLoading,
    messages: listState.messages,
    error: listState.error,
    setMessageState
  };
}